import { Button, Dialog } from '@mcgames/ui';
import { useTranslation } from 'react-i18next';
import { ErrorText } from './games/ErrorText.tsx';

export type ConfirmDialogProps = {
  title: string;
  message: string;
  confirmLabel: string;
  /** `danger` for actions that cut access or delete something. */
  tone?: 'primary' | 'danger';
  pending: boolean;
  error: unknown;
  onConfirm: () => void;
  onCancel: () => void;
};

/** An open modal that asks before a destructive or access-changing action; render it only while asking. */
export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  tone = 'danger',
  pending,
  error,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { t } = useTranslation('common');
  return (
    <Dialog
      open
      onClose={onCancel}
      title={title}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>
            {t('actions.cancel')}
          </Button>
          <Button variant={tone} disabled={pending} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p>{message}</p>
      <ErrorText error={error} />
    </Dialog>
  );
}
